import React from 'react';
import { DynamicRangeSlider, SingleList } from '@appbaseio/reactivesearch';
import { Grid, Drawer, withStyles, Button } from '@material-ui/core';

const styles = (theme) => ({
	drawer: {
		width: 300,
		flexShrink: 0,
		padding: '20px',
	},
	filter: {
		backgroundColor: theme.palette.background.paper,
		padding: '10px',
		border: `1px solid ${theme.palette.grey['300']}`,
		marginBottom: 20,
	},
	drawerButton: {
		position: 'fixed',
		bottom: 0,
		left: 0,
		zIndex: 9,
		borderRadius: 0,
	},
});

const Filters = ({ classes }) => (
	<React.Fragment>
		<SingleList
			className={classes.filter}
			componentId="platform"
			dataField="Platform.keyword"
			URLParams
			renderNoResults={() => 'No Results Found!'}
			placeholder="Filter by console"
		/>
		<DynamicRangeSlider
			className={classes.filter}
			componentId="year"
			dataField="Year_of_Release_Int"
			showHistogram
			title="Filter by year"
			tooltipTrigger="hover"
			URLParams
		/>
	</React.Fragment>
);

class AllFilters extends React.Component {
	state = {
		isDrawer: false,
	};

	handleDrawer = () => {
		this.setState((prevState) => ({
			isDrawer: !prevState.isDrawer,
		}));
	};

	render() {
		const isMobile = window.innerWidth < 576;
		const { isDrawer } = this.state;
		const { classes } = this.props;
		return isMobile ? (
			<React.Fragment>
				<Drawer
					variant="temporary"
					open={isDrawer}
					id="filters"
					key="filters"
					anchor="right"
					onClose={this.handleDrawer}
					className={classes.drawer}
				>
					<Filters {...this.props} />
				</Drawer>
				<Button
					fullWidth
					className={classes.drawerButton}
					color="primary"
					variant="contained"
					onClick={this.handleDrawer}
				>
					Show Filters
				</Button>
			</React.Fragment>
		) : (
			<Grid item sm={3} xs={12}>
				<Filters {...this.props} />
			</Grid>
		);
	}
}

export default withStyles(styles)(AllFilters);
